import AdminHeader from "components/Headers/AdminHeader";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { urlEncodedId } from "components/CommonComponents/encodeDecodeFunction";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Button,
  UncontrolledTooltip,
  Row,
  Col,
  Input,
  Container,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getDocumentsApprovalList } from "action/documentsApproval";
import { documentsApprovalList } from "constants/documentsApproval";
import { DEFAULT_RECORDS_PER_PAGE } from "components/constant";

const DocumentsApproval = () => {
  const dispatch = useDispatch();
  const documentsApprovalDataList = useSelector(
    (state) => state.documentsApproval.documentsApprovalList,
  );
  const navigate = useNavigate();
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const [pageNum, setPageNum] = useState(1);
  const [searchState, setSearchState] = useState({
    jointerId: "",
    traineeName: "",
    email: "",
    filterParams: [],
  });
  const [alternative, setAlternative] = useState({
    isLoading: true,
    showLoaderOnClick: false,
    error: "",
    noRecords: false,
  });

  const buildFilterParams = () => {
    const filterParams = [];

    if (searchState.jointerId?.trim()) {
      filterParams.push({
        field: "JointerID",
        condition: "like",
        filterValues: [searchState.jointerId.trim()],
      });
    }

    if (searchState.traineeName?.trim()) {
      filterParams.push({
        field: "FullName",
        condition: "like",
        filterValues: [searchState.traineeName.trim()],
      });
    }

    return {
      filters: filterParams.length > 0 ? JSON.stringify(filterParams) : [],
    };
  };
  const formattedDocumentApprovalList =
    documentsApprovalDataList?.data?.trainees?.map((item, index) => {
      return {
        ...item,

        ID: item?.traineeId,

        jointerId: item?.jointerId,

        traineeName: item?.traineeName || "",

        uploadedBy: item?.uploadedBy || "",
        uploadedByEmail: item?.uploadedByEmail || "",
        mobile: item?.mobile || "",

        totalDocuments: item?.totalDocuments || 0,
        pendingDocuments: item?.pendingDocuments || 0,
        approvedDocuments: item?.approvedDocuments || 0,
        rejectedDocuments: item?.rejectedDocuments || 0,

        srNo:
          (pageNum - 1) *
            (documentsApprovalDataList?.data?.noOfRecordsPerPage ||
              DEFAULT_RECORDS_PER_PAGE) +
          index +
          1,
      };
    }) || [];

  useEffect(() => {
    setAlternative((prev) => ({
      ...prev,
      isLoading: true,
    }));

    getDocumentsApprovalList(dispatch, pageNum, buildFilterParams());

    return () => {
      dispatch({
        type: documentsApprovalList,
        payload: {},
      });
    };
  }, [dispatch, pageNum, searchState.filterParams]);

  useEffect(() => {
    if (documentsApprovalDataList?.code === 200) {
      setAlternative({
        isLoading: false,
        error: "",
        noRecords: documentsApprovalDataList?.data?.trainees?.length === 0,
        showLoaderOnClick: false,
      });
    } else if (
      documentsApprovalDataList?.code ||
      documentsApprovalDataList?.message
    ) {
      setAlternative({
        isLoading: false,
        error:
          documentsApprovalDataList?.message ||
          "Failed to load documents approval list! Please try again.",
        noRecords: false,
        showLoaderOnClick: false,
      });
    }
  }, [documentsApprovalDataList]);

  const handleViewDocument = (row) => {
  const encodedId = urlEncodedId(row.traineeId);

  navigate(
    role === "SUPER_ADMIN"
      ? `/super-admin/trainee/${encodedId}/details?tab=documents`
      : role === "CHANNEL_PARTNER"
        ? `/channel-partner/trainee/${encodedId}/details?tab=documents`
        : `/admin/trainee/${encodedId}/details?tab=documents`,
    {
      state: {
        from: "documents-approval",
      },
    },
  );
};

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleSearch = () => {
    if (
      !searchState.jointerId.trim() &&
      !searchState.traineeName.trim() 
        ) {
        
      return;
    }

    const newFilterParams = buildFilterParams();

    if (
      JSON.stringify(searchState.filterParams) !==
      JSON.stringify(newFilterParams)
    ) {
      setAlternative((prev) => ({
        ...prev,
        isLoading: true,
        showLoaderOnClick: true,
      }));

      setSearchState((prev) => ({
        ...prev,
        filterParams: newFilterParams,
      }));

      if (pageNum !== 1) {
        setPageNum(1);
      }
    }
  };

  const clearSearch = () => {
    setAlternative((prev) => ({
      ...prev,
      isLoading: true,
    }));

    setSearchState({
      jointerId: "",
      traineeName: "",
      filterParams: [],
    });

    if (pageNum !== 1) {
      setPageNum(1);
    }
  };

  const columns = [
    {
      Header: "Sr. No.",
      accessor: "srNo",
      minWidth: 60,
      maxWidth: 70,
      centerAlign: true,
    },

    {
      Header: "Jointer ID",
      accessor: "jointerId",
      minWidth: 120,
      maxWidth: 160,
      Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
    },

    {
      Header: "Trainee Name",
      accessor: "traineeName",
      minWidth: 160,
      maxWidth: 250,
      Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
    },

    {
      Header: "Uploaded By",
      accessor: "uploadedBy",
      minWidth: 180,
      maxWidth: 250,
      Cell: ({ row }) => {
        const { uploadedBy, uploadedByEmail, mobile } = row.original;

        return (
          <div className="d-flex flex-column text-wrapper">
            <span className="mb-1 d-flex align-items-start">
              <i className="fas fa-user mr-2 text-muted flex-shrink-0 contact-info-icon" />
              <span className="mt--1">{uploadedBy || "-"}</span>
            </span>

            <span className="mb-1 d-flex align-items-start">
              <i className="fas fa-envelope mr-2 text-muted flex-shrink-0 contact-info-icon" />
              <span className="mt--1">{uploadedByEmail || "-"}</span>
            </span>

            {mobile && (
              <span className="d-flex align-items-start">
                <i className="fas fa-phone mr-2 text-muted flex-shrink-0 contact-info-icon" />
                <span className="mt--1">{mobile}</span>
              </span>
            )}
          </div>
        );
      },
    },
    {
      Header: "Total & Pending Documents",
      accessor: "totalDocuments",
      minWidth: 180,
      maxWidth: 230,
      Cell: ({ row }) => (
        <div className="d-flex flex-column">
          <div className="text-muted">
            Total : {row.original.totalDocuments || 0}
          </div>

          <div className="text-muted">
            Pending : {row.original.pendingDocuments || 0}
          </div>
        </div>
      ),
    },

    {
      Header: "Approved & Rejected Documents",
      accessor: "approvedDocuments",
      minWidth: 200,
      maxWidth: 260,
      Cell: ({ row }) => (
        <div className="d-flex flex-column">
          <div className="text-muted">
            Approved : {row.original.approvedDocuments || 0}
          </div>

          <div className="text-muted">
            Rejected : {row.original.rejectedDocuments || 0}
          </div>
        </div>
      ),
    },

   ...(role !== "CHANNEL_PARTNER"
  ? [
      {
        Header: "Action",
        accessor: "action",
        minWidth: 80,
        maxWidth: 100,
        Cell: ({ row }) => (
          <>
            <Button
              type="button"
              className="btn-link d-flex align-items-center p-0"
              size="sm"
              id={`view-document-${row.original.traineeId}`}
              onClick={(e) => {
                e.stopPropagation();
                handleViewDocument(row.original);
              }}
            >
              <i className="fas fa-eye table-action-primary" />
            </Button>

            <UncontrolledTooltip
              placement="top"
              target={`view-document-${row.original.traineeId}`}
            >
              View Documents
            </UncontrolledTooltip>
          </>
        ),
      },
    ]
  : []),
  ];
  return (
    <>
      <AdminHeader />

      <Container fluid className="mt--6">
        <Row>
          <Col md="12">
            <Card>
              {/* Header */}
              <CardHeader className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2">
              <CardTitle tag="h3" className="mb-0 text-default">
                  Documents Approval
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                  <div className="d-flex flex-wrap align-items-center filter-group">
                    <Input
                      type="text"
                      placeholder="Search by jointer ID"
                      className="mr-2 mb-2 filter-input-large"
                      value={searchState.jointerId}
                      onChange={(e) =>
                        setSearchState((prev) => ({
                          ...prev,
                          jointerId: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />
                    <Input
                      type="text"
                      placeholder="Search by trainee name"
                      className="mr-2 mb-2 filter-input-large"
                      value={searchState.traineeName}
                      onChange={(e) =>
                        setSearchState((prev) => ({
                          ...prev,
                          traineeName: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />
                    
                    <Button
                      color="default"
                      className={`d-flex align-items-center mb-2 filter-btn btn-deep-blue ${
                        alternative.showLoaderOnClick ? "search-btn" : ""
                      }`}
                      onClick={handleSearch}
                    >
                      {alternative.showLoaderOnClick ? (
                        <i className="fa fa-spinner fa-spin loader" />
                      ) : (
                        <>
                          <i className="fa fa-search mr-1" />
                          Search
                        </>
                      )}
                    </Button>
                    {searchState.filterParams?.filters?.length > 0 && (
                      <Button
                        color="default"
                        className="d-flex align-items-start mb-2 ml-0 filter-btn btn-deep-blue px-4"
                        onClick={clearSearch}
                      >
                        <i className="fa fa-times mr-1 mt-1" /> Clear
                      </Button>
                    )}{" "}
                  </div>
                </div>
                <div className="mt-2 mb-3 mx-1">
                  {documentsApprovalDataList?.data?.totalRecords ? (
                    <>
                      {searchState.filterParams?.filters?.length > 0 ? (
                        <span className="total-records">
                          Showing{" "}
                          {
                            documentsApprovalDataList?.data
                              ?.totalFilteredRecords
                          }{"  "}
                          of {documentsApprovalDataList?.data?.totalRecords}{" "}
                          Records
                        </span>
                      ) : (
                        <span className="total-records">
                          Total Records :{" "}
                          {documentsApprovalDataList?.data?.totalRecords}
                        </span>
                      )}
                    </>
                  ) : null}
                </div>
                {alternative.isLoading ? (
                  <div className="loaderContainer">
                    <i className="fa fa-spinner fa-spin fa-2xl loader" />
                  </div>
                ) : alternative.error ? (
                  <div className="loaderContainer error-style">
                    <div className="error-icon">
                      <i className="fa-solid fa-circle-exclamation"></i>
                    </div>
                    <span>{alternative.error}</span>
                  </div>
                ) : alternative.noRecords ? (
                  <div className="loaderContainer empty-style">
                    <div className="empty-icon">
                      <i className="fa-solid fa-circle-info"></i>
                    </div>
                    <span>No documents found.</span>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <CommonTable
                      columns={columns}
                      data={formattedDocumentApprovalList || []}
                      defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                      activePage={pageNum}
                      setPageNum={setPageNum}
                      totalPages={Math.ceil(
                        documentsApprovalDataList?.data?.totalFilteredRecords /
                          documentsApprovalDataList?.data?.noOfRecordsPerPage,
                      )}
                      showPaginationBottom={true}
                      rowClick={(row) => handleViewDocument(row)}
                    />{" "}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DocumentsApproval;
